import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import useProviderCounts from '../filters/useProviderCounts'
import type { MrtCountTarget } from '../mrtCollectionTypes'
import { createSpendToFilterGroups, spendFilterFields, spendGroupCountSelections } from './spendFilterValue'

const toProviderFilterGroups = createSpendToFilterGroups(spendFilterFields('spends'))

/** How many rows each spend group, and no spend, holds in the period: the countTarget's rows, or all the
 * organization's suppliers without one. */
const useSpendGroupCounts = (
  periodName: string | undefined,
  spendClassifications: string[],
  otherFilterGroups: FilterGroup[],
  countTarget?: MrtCountTarget,
): { countByGroup: Map<string, number>; isLoading: boolean } => {
  const selections = periodName ? spendGroupCountSelections(periodName, spendClassifications) : []
  const { countByKey, isLoading } = useProviderCounts(
    selections.map(({ key, selection }) => ({ key, payload: toProviderFilterGroups(selection, 'is') })),
    otherFilterGroups,
    countTarget,
  )
  return { countByGroup: countByKey, isLoading }
}

export default useSpendGroupCounts
